import React from 'react';
import { motion } from 'framer-motion';

const RefundCancellationPolicyPage = ({ onBack }) => {
  return (
    <div style={{ backgroundColor: '#ffffff', minHeight: '100vh' }}>
      {/* Back Button */}
      <motion.div 
        style={{ 
          padding: '20px',
          position: 'fixed',
          top: '20px',
          left: '20px',
          zIndex: 1000
        }}
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6 }}
      >
        <button 
          onClick={onBack}
          style={{
            background: '#7c3aed',
            color: 'white',
            border: 'none',
            padding: '12px 24px',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '16px',
            fontWeight: '600',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            boxShadow: '0 4px 12px rgba(124, 58, 237, 0.3)',
            transition: 'all 0.3s ease'
          }}
          onMouseOver={(e) => {
            e.target.style.background = '#6d28d9';
            e.target.style.transform = 'translateY(-2px)';
          }}
          onMouseOut={(e) => {
            e.target.style.background = '#7c3aed';
            e.target.style.transform = 'translateY(0px)';
          }}
        >
          ← Back to Home
        </button>
      </motion.div>

      <motion.div 
        className="refund-cancellation-policy-page"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        style={{
          padding: '120px 20px 50px 20px',
          maxWidth: '1200px',
          margin: '0 auto',
          lineHeight: '1.6',
          color: '#333',
          backgroundColor: '#ffffff'
        }}
      >
        <motion.h1 
          style={{
            fontSize: '3rem',
            marginBottom: '20px',
            color: '#7c3aed',
            textAlign: 'center'
          }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          💰 Refund & Cancellation Policy
        </motion.h1>
        
        <motion.p 
          style={{
            fontSize: '1.2rem',
            fontWeight: 'bold',
            textAlign: 'center',
            marginBottom: '40px',
            color: '#7c3aed'
          }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          Effective Date: 20/12/2024
        </motion.p>

        <motion.section 
          style={{ marginBottom: '40px' }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          <h2 style={{ fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '20px', color: '#7c3aed' }}>
            1. Subscriptions
          </h2>
          <ul style={{ paddingLeft: '20px', lineHeight: '2' }}>
            <li>All plans are prepaid and billed monthly.</li>
          </ul>
        </motion.section>

        <motion.section 
          style={{ marginBottom: '40px' }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.5 }}
        >
          <h2 style={{ fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '20px', color: '#7c3aed' }}>
            2. Refund Policy
          </h2>
          <ul style={{ paddingLeft: '20px', lineHeight: '2' }}>
            <li>No refunds for used or partially used subscription periods.</li>
            <li>Refunds are not provided for non-conversion of leads.</li>
            <li>Refunds are only processed if:
              <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
                <li>Services were not delivered as promised.</li>
                <li>Duplicate charges occurred due to technical errors.</li>
              </ul>
            </li>
          </ul>
        </motion.section>

        <motion.section 
          style={{ marginBottom: '40px' }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <h2 style={{ fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '20px', color: '#7c3aed' }}>
            3. Cancellation Policy
          </h2>
          <ul style={{ paddingLeft: '20px', lineHeight: '2' }}>
            <li>Clients may cancel subscriptions with <strong>30 days' written notice</strong>.</li>
            <li>Cancellations take effect from the next billing cycle.</li>
          </ul>
        </motion.section>

        <motion.section 
          style={{ marginBottom: '40px' }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.7 }}
        >
          <h2 style={{ fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '20px', color: '#7c3aed' }}>
            4. Special Notes
          </h2>
          <ul style={{ paddingLeft: '20px', lineHeight: '2' }}>
            <li>LeadVala reserves the right to refuse refunds if leads were misused or policies were violated.</li>
          </ul>
        </motion.section>
      </motion.div>
    </div>
  );
};

export default RefundCancellationPolicyPage;